import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getActiveInspection, setReportCheckFlag, setReportGeneratedFlag } from '../actions/inspections';
import DocumentTitle from '../components/DocumentTitle';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import PageLoader from '../components/partials/PageLoader';
import Questions from '../components/report/Questions';
import ReportGenerated from '../components/report/ReportGenerated';
import __ from '../helpers/translation';

const propTypes = {
  inspection: PropTypes.object.isRequired,
  getActiveInspection: PropTypes.func.isRequired,
  setReportCheckFlag: PropTypes.func.isRequired,
  setReportGeneratedFlag: PropTypes.func.isRequired
};

class Report extends Component {

  constructor (props) {
    super(props);
  }

  loadRunningInspection() {
    this.setState({ checkingReport: true });
    this.props.getActiveInspection()
        .then(data => {
          this.props.setReportCheckFlag(true);
        })
        .catch(error => {
          console.log(error)
        });
  }

  componentDidMount () {
    document.body.classList.add('bg-grey');
    if(!this.props.inspection.report && !this.props.inspection.reportChecked){
      this.loadRunningInspection();
    }
  }

  componentWillUnmount () {
    document.body.classList.remove(... document.body.classList);
  }

  render () {

    // Oorspronkelijke code (tijdelijk gecommentarieerd)
    // if(this.props.inspection.reportGenerated){
    //   return <ReportGenerated onStartNew={() => this.props.setReportGeneratedFlag(false) } />
    // }
    
    // Altijd het ReportGenerated component tonen wanneer een form wordt afgerond
    // We bewaren de oude voorwaarde in commentaar zodat deze later kan worden hersteld
    // Dit zorgt ervoor dat gebruikers altijd het succesvolle afrondignsscherm zien
    if(this.props.inspection.reportGenerated || (this.props.inspection.report && this.props.inspection.report.state === 'completed')){
      return <ReportGenerated onStartNew={() => this.props.setReportGeneratedFlag(false) } />
    }

    if(!this.props.inspection.report){
      return <Redirect to={{ pathname: '/home' }} />
    }

    if(!this.props.inspection.reportChecked){
      return (
        <PageLoader text={ __('app.inspections.checking_report_loader') } />
      )
    }

    return (
      <DocumentTitle title={`${__('app.navigation.inspections')} - ${window.App.name}`}>
        <Questions />
      </DocumentTitle>
    );
  }
}

Report.propTypes = propTypes;

const mapDispatchToProps = {
  getActiveInspection,
  setReportCheckFlag,
  setReportGeneratedFlag
};

const mapStateToProps = ({inspection}) => ({ inspection });

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Report));
